import { useAtom } from '@reatom/npm-react'
import { motion } from 'motion/react'
import styled from 'styled-components'

import { isLoggedInAtom } from '@root/entities/auth'
import { tradeOrderTypeAtom } from '@root/features/trade/trading'
import { AnimateHeight } from '@root/shared/ui-kit'

import { TradingControlsSellButton } from '../../common/trading-controls-sell/trading-controls-sell-button'
import { TradingControlsLimitSell } from '../../common/trading-controls-sell/trading-controls-sell-limit'
import { TradingControlsSellQuote } from '../../common/trading-controls-sell/trading-controls-sell-quote'
import { TradingGas } from '../trading-gas'

import { TradingControlsAmountSell } from './trading-controls-sell-amount'

import type { SellControlsModel } from '../../../atoms/common'
import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
  onSettingsOpen: () => void
  model: SellControlsModel
}

export const TradingControlsSellForm: React.FC<Props> = ({
  pair,
  onSettingsOpen,
  model,
}) => {
  const [tradeOrderType] = useAtom(tradeOrderTypeAtom)
  const [isLoggedIn] = useAtom(isLoggedInAtom)

  return (
    <Root>
      <TradingControlsAmountSell model={model.inputModel} pair={pair} />
      {tradeOrderType === 'limit' ? (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <TradingControlsLimitSell model={model.limitModel} pair={pair} />
        </motion.div>
      ) : undefined}
      {isLoggedIn ? <TradingGas onSettingsOpen={onSettingsOpen} /> : undefined}
      <QuoteSellGroup>
        <AnimateHeight>
          <TradingControlsSellQuote model={model} pair={pair} />
        </AnimateHeight>
        <SellButton model={model} pair={pair} />
      </QuoteSellGroup>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 10px;
`

const SellButton = styled(TradingControlsSellButton)`
  margin-inline: 10px;
`

const QuoteSellGroup = styled.div`
  display: grid;
`
